import React, { FC } from 'react'
import { useHistory } from 'react-router-dom'
import { Grid, Typography, makeStyles, Theme } from '@material-ui/core'

import { PillButton } from 'components'
import WelcomeBG from 'assets/welcome-header.png'
import { EventStages } from 'types'

import { ReactComponent as ISLogo } from 'assets/5GIS-black.svg'

interface MobileWelcomeProps {
  eventStage?: EventStages
}

export const MobileWelcome: FC<MobileWelcomeProps> = ({ eventStage }) => {
  const history = useHistory()
  const classes = useStyles()

  const watchLiveStream = () => {
    if (eventStage !== EventStages.POSTEVENT) {
      history.push(`/stream`)
    } else {
      history.push(`/event/event-replay/full-show`)
    }
  }

  return (
    <div className={classes.root}>
      <Grid container>
        <Grid item xs={12}>
          <img className={classes.image} src={WelcomeBG} alt='Verizon 5G Logo' />
        </Grid>
        <Grid container item xs={12} className={classes.contentContainer}>
          <Grid item xs={12}>
            <ISLogo className={classes.ISLogo} />
            <Typography variant='h1' component='h1' className={classes.hideElement}>
              5G Innovation Sessions
            </Typography>

            <Typography component='h1' variant='h3' paragraph>
              Supporting Public Safety on the frontline
            </Typography>
            <Typography paragraph>
              Public Safety agencies are looking for ways to become more agile with 5G to better support First
              Responders and their communities.
            </Typography>
            <Typography paragraph>
              During this hour-long event, Verizon will explain why 5G matters to First Responders today and in the
              future. The discussion will include new technology solutions and public safety-focused use cases.
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <PillButton onClick={watchLiveStream}>
              {eventStage !== EventStages.POSTEVENT ? 'Watch livestream' : 'Watch event replay'}
            </PillButton>
          </Grid>
        </Grid>
      </Grid>
    </div>
  )
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1
  },
  image: {
    width: '100%'
  },
  contentContainer: {
    padding: '2rem'
  },
  ISLogo: {
    height: 216,
    marginBottom: '1rem',
    [theme.breakpoints.down('lg')]: {
      height: 168
    },
    [theme.breakpoints.down('md')]: {
      height: 162
    },
    [theme.breakpoints.down('sm')]: {
      height: 140
    }
  },
  hideElement: {
    border: 0,
    clip: 'rect(1px, 1px, 1px, 1px)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    width: 1
  }
}))
